/*
 * Weather-history popup. Same visual treatment as Calendar's
 * DayDetail dialog so the two read as a matched pair: dimmed +
 * blurred backdrop, lifted frosted-glass panel with the accent ring.
 */

.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(8, 18, 12, 0.5);
  backdrop-filter: blur(10px) saturate(140%);
  -webkit-backdrop-filter: blur(10px) saturate(140%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: clamp(20px, 3vw, 48px);
  animation: weatherHistoryBackdrop 180ms ease-out;
}

.panel {
  position: relative;
  width: 100%;
  /* Both charts (daily temperature + per-kind tally) should fit on
   * the screen at once without scrolling. The card grows up to 95vh
   * and 95vw — overflow only kicks in for truly extreme content. */
  max-width: min(1600px, 95vw);
  max-height: 95vh;
  overflow: auto;
  padding: clamp(16px, 1.6vw, 24px) clamp(20px, 2.2vw, 36px);
  display: flex;
  flex-direction: column;
  gap: clamp(14px, 1.4vw, 22px);
  font-family: var(--token-font-body);
  color: var(--token-text-primary);
  outline: 1.5px solid var(--token-accent);
  outline-offset: -1.5px;
  border-radius: 28px;
  box-shadow:
    0 60px 120px -20px rgba(8, 18, 12, 0.55),
    0 24px 48px -12px rgba(8, 18, 12, 0.4),
    inset 0 2px 0 rgba(255, 255, 255, 0.85);
  animation: weatherHistoryPanel 220ms cubic-bezier(0.22, 0.9, 0.3, 1.15);
}

@keyframes weatherHistoryBackdrop {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes weatherHistoryPanel {
  from {
    transform: translateY(8px) scale(0.96);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--token-space-md);
  border-bottom: 2px dotted var(--token-accent);
  padding-bottom: clamp(6px, 0.8vw, 12px);
}

.heading {
  margin: 0;
  font-family: var(--token-font-display);
  font-size: clamp(24px, 2.2vw, 36px);
  color: var(--token-text-primary);
}

.close {
  min-width: 44px;
  min-height: 44px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(28, 38, 32, 0.18);
  background: rgba(255, 255, 255, 0.7);
  color: rgba(28, 38, 32, 0.7);
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.close:hover {
  background: #fff;
  color: var(--token-text-primary);
}
